export default "__VITE_ASSET__CyW862To__"